import { MDXProvider } from '@mdx-js/react'
import ApiEndpoint from 'components/ApiEndpoint/ApiEndpoint'
import * as Article from 'components/ArticleComponents'
import CloneButton from 'components/CloneButton'
import Copyable from 'components/Copyable'
import LocaleTable from 'components/LocaleTable'
import CurrencyList from 'components/CurrencyList'
import CountryList from 'components/CountryList'

import { default as Tabs, Tab } from 'components/Tabs'
import ColorTag, { OptionalTag, ThreeDSTag, TxnTag } from 'components/Tag'
import UserContext from 'components/UserContext'
import Callout from 'ds/Callout'
import ContentGrid, { GridItem } from 'ds/ContentGrid'
import ContentSwitcher, { ContentSwitcherStickyContainer, ContentSwitcherStickyWrapper } from 'ds/ContentSwitcher'
import DefinitionList, { DD, DT, DTHeader } from 'ds/DefinitionList'
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer'
import Test3DSCardsSection from 'pages-content/payments/Test3DSCardsSection'
import TestCardsSection from 'pages-content/payments/TestCardsSection'
import TestCardsTable from 'pages-content/payments/TestCardsTable'
import TestDeclinedFailedCardsSection from 'pages-content/payments/TestDeclinedFailedCardsSection'
import React from 'react'
import AutomationOverview from '../../pages-content/automation/Overview'
import ReconciliationOverview from '../../pages-content/reconciliation/Overview'
import ObsOverview from '../../pages-content/observability/Overview'
import PaymentsOverview from '../../pages-content/payments/Overview'
import UniversalCheckoutOverview from '../../pages-content/universal-checkout/Overview'
import AnchorLink from '../AnchorLink'
import { Group } from '../Group'
import { Item } from '../Item'
import PathBreakdown, { PathBreakdownProvider } from '../PathBreakdown'
import PaymentMethodTable from '../PaymentMethodTable'

const Empty = props => {
	return props.children ?? <></>
}

const ContentSwitcherWrapper =
	({ parentLocation, location, contentSwitcherContent }) =>
	() => {
		const Content = (
			<ContentSwitcherStickyWrapper as={Article.Wrapper}>
				<ContentSwitcherStickyContainer>
					<ContentSwitcher parentLocation={parentLocation} location={location} />
				</ContentSwitcherStickyContainer>

				{contentSwitcherContent}
			</ContentSwitcherStickyWrapper>
		)

		return Content
	}

const getCustomMDXComponents = ({ ...props } = {}) => ({
	h1: Article.H1,
	H1: Article.H1,
	h2: Article.H2,
	H2: Article.H2,
	h3: Article.H3,
	H3: Article.H3,
	h4: Article.H4,
	H4: Article.H4,
	h5: Article.H5,
	H5: Article.H5,
	h6: Article.H6,
	H6: Article.H6,
	p: Article.P,
	a: Article.A,
	code: Article.Code,
	pre: Article.StyledCodeBlock,
	table: Article.HorizontalScrollTable,
	blockquote: Article.Blockquote,
	ol: Article.OrderedList,
	ul: Article.UnorderedList,
	hr: Article.HR,
	CodeBlock: Article.StyledCodeBlock,
	Copyable: Copyable,
	Callout: Callout,
	TableOfContents: Empty,
	ContentSwitcher: ContentSwitcherWrapper(props),
	UserContext: UserContext,
	Check: Article.Check,
	Tabs,
	Tab,
	AnchorLink: AnchorLink,
	ContentGrid: ContentGrid,
	GridItem: GridItem,

	DefinitionList,
	DT,
	DD,
	DTHeader,

	ColorTag,
	TxnTag,
	ThreeDSTag,
	OptionalTag,
	PathBreakdownProvider,
	PathBreakdown,
	SmallSeparator: Article.SmallSeparator,
	ApiEndpoint,
	Footnote: Article.Footnote,
	Headnote: Article.Headnote,
	CloneButton,
	AutomationOverview,
	ReconciliationOverview,
	ObsOverview,
	PaymentsOverview,
	UniversalCheckoutOverview,
	Item,
	Group,

	CurrencyList,
	CountryList,

	LocaleTable,
	TestCardsTable,
	TestCardsSection,
	Test3DSCardsSection,
	TestDeclinedFailedCardsSection,
	PaymentMethodTable,
})

export default getCustomMDXComponents

export const Renderer = props => {
	return (
		props.children && (
			<MDXProvider components={getCustomMDXComponents(props)}>
				<MDXRenderer {...props} />
			</MDXProvider>
		)
	)
}
